var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("FormButtonDisabler", [
    _c("div", { staticClass: "w-full flex pt-2 flex-col" }, [
      _c(
        "div",
        { staticClass: "flex flex-col form w-full" },
        [
          _vm.mergeType == "package"
            ? _c(
                "field",
                { attrs: { inline: "", label: "Package Name" } },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.selectedPkgs,
                      "text-field": "packageName",
                      "value-field": "id",
                      "auto-assign": "",
                    },
                    model: {
                      value: _vm.mergeTarget,
                      callback: function ($$v) {
                        _vm.mergeTarget = $$v
                      },
                      expression: "mergeTarget",
                    },
                  }),
                ],
                1
              )
            : _c(
                "field",
                { attrs: { inline: "", label: "Deal Name" } },
                [
                  _c("dropdown-field", {
                    attrs: {
                      source: _vm.selectedPkgs,
                      "text-field": "dealName",
                      "value-field": "id",
                      "auto-assign": "",
                    },
                    model: {
                      value: _vm.mergeTarget,
                      callback: function ($$v) {
                        _vm.mergeTarget = $$v
                      },
                      expression: "mergeTarget",
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _c(
            "field",
            { staticClass: "mb-2", attrs: { label: "Reason" } },
            [
              _c("textarea-field", {
                model: {
                  value: _vm.description,
                  callback: function ($$v) {
                    _vm.description = $$v
                  },
                  expression: "description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-row-reverse pt-4" },
        [
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Merge")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }